import type { WaitlistRequest, WaitlistResponse } from '../../../shared/api/types';
import { supabase, isSupabaseConfigured, EMAILS_TABLE } from '../../../lib/supabase';

/**
 * Отправка email в waitlist через Supabase
 */
export const submitWaitlistEmail = async (
  request: WaitlistRequest
): Promise<WaitlistResponse> => {
  const { email } = request;

  if (!email || !email.trim()) {
    return {
      success: false,
      error: 'Email is required',
    };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return {
      success: false,
      error: 'Invalid email format',
    };
  }

  if (!isSupabaseConfigured() || !supabase) {
    return {
      success: false,
      error: 'Supabase is not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY environment variables.',
    };
  }

  try {
    const insertData = {
      email,
      created_at: new Date().toISOString(),
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { error: insertError } = await (supabase as any)
      .from(EMAILS_TABLE)
      .insert(insertData);

    if (insertError) {
      const errorMessage = insertError.message || insertError.code || '';
      if (errorMessage.includes('duplicate') || errorMessage.includes('unique')) {
        return {
          success: false,
          error: 'This email is already registered.',
        };
      }

      throw insertError;
    }

    return {
      success: true,
      message: 'Email successfully added to waitlist',
    };
  } catch (err) {
    const errorMessage = (err as { message?: string; code?: string })?.message 
      || (err as { message?: string; code?: string })?.code
      || 'An error occurred while saving. Please try again.';

    return {
      success: false,
      error: errorMessage,
    };
  }
};
